const defaultFormatter = (messages, ctx) => {
  const msgs = [...messages];
  if (ctx.name) {
    msgs.unshift(`[${ctx.name}]`);
  }

  return msgs;
};

export class Logger {
  // logger支持的打印方法列表，有序，索引值为level级别
  static LOG_METHODS = ['trace', 'debug', 'info', 'warn', 'error'];
  // 不同方法对应的打印级别
  static LEVELS = {}

  /**
   * 日志打印
   * @param {String} name 系统标识
   * @param {Object} options 自定义选项
   * @param {Number} options.level 打印级别，低于该级别的日志将不会被打印
   * @param {Function} options.formatter 打印格式函数，接收一个打印方法参数的数组和当前logger对象，需返回数组格式
   */
  constructor(name, { level, formatter } = {}) {
    this.name = name;
    this.formatter = formatter || defaultFormatter;
    this.setLevel(level);

    // 动态初始化logger方法
    Logger.LOG_METHODS.forEach((logMethod) => {
      this[logMethod] = (...messages) => {
        this.invoke(logMethod, messages);
      };
    });
  }

  invoke(type, messages) {
    if (this.level > Logger.LEVELS[type]) {
      return;
    }

    try {
      console[type](...this.formatter(messages, this));
    } catch (e) {
      console.error(`[logger] Failed to print logger.${type} because of: `, e);
    }
  }

  /**
   * 更新打印级别，需在初始化完成后调用
   * @param {Number | Undefined} val 打印级别，默认会根据运行环境设置
   */
  setLevel(val) {
    if (typeof val === 'number') {
      this.level = val;
    } else {
      // 以防未编译直接在浏览器环境调用，try一下
      try {
        // 默认开发环境全部打印，生产环境打印最后两个级别
        this.level = process.env.NODE_ENV === 'production'
          ? Logger.LEVELS[Logger.LOG_METHODS[Logger.LOG_METHODS.length - 2]]
          : Logger.LEVELS[Logger.LOG_METHODS[0]];
      } catch (e) {
        this.level = Logger.LEVELS[Logger.LOG_METHODS[0]];
        console.error('[logger] Set default level to 0 because of:', e);
      }
    }
  }

  getLevel() {
    return this.level;
  }
}

// 动态初始化各方法的level
Logger.LOG_METHODS.forEach((logMethod, index) => {
  Logger.LEVELS[logMethod] = index;
});

export default new Logger('vft-common');
